const UserValidation = (values) => {
  const errors = {};
  if (!values.username) {
    errors.username = "Username is required!";
  }
  if (values.username && values.username.search(" ") !== -1) {
    errors.username = "Username should not contain space";
  }

  if (!values.firstname) {
    errors.firstname = "Firstname is required";
  }

  if (!values.lastname) {
    errors.lastname = "Lastname is required";
  }

  if (!values.phone) {
    errors.phone = "Phone is required";
  }

  if (!values.email) {
    errors.email = "Email is required";
  }

  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }
  if (!values.role_id) {
    // You can return translation keys
    errors.role_id = "Role is required";
  }

  if (!values.branchSelected) {
    // You can return translation keys
    errors.branchSelected = "Branch is required";
  }

  return errors;
};

export default UserValidation;
